// Trimmed ABI containing only the constructor for the OpenZeppelin ERC1967Proxy contract.
export const OZ_ERC1967Proxy_ConstructorAbi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_logic",
        type: "address",
        internalType: "address",
      },
      {
        name: "_data",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    stateMutability: "payable",
  },
] as const;
